import { InjectionToken } from "tsyringe";

import CurrencyProviderInterface from "./CurrencyProvider/CurrencyProviderInterface";
import MoneyFormatterInterface from "./Formatters/MoneyFormatter/MoneyFormatterInterface";
import HTMLSanitizerInterface from "./HTMLSanitizer/HTMLSanitizerInterface";
import MoneyExchangerInterface from "./MoneyExchanger/MoneyExchangerInterface";

export const moneyExchangerToken = Symbol(
    "moneyExchangerToken"
) as InjectionToken<MoneyExchangerInterface>;

export const moneyFormatterToken = Symbol(
    "moneyFormatterToken"
) as InjectionToken<MoneyFormatterInterface>;

export const currencyProviderToken = Symbol(
    "currencyProvider"
) as InjectionToken<CurrencyProviderInterface>;

export const htmlSanitizerToken = Symbol(
    "htmlSanitizer"
) as InjectionToken<HTMLSanitizerInterface>;
